export var paddingOption = {
    sm: '6px',
    md: '10px',
    lg: '14px'
};
export var heightOption = {
    sm: '32px',
    md: '40px',
    lg: '56px'
};
export var fontSizeOption = {
    sm: '14px',
    md: '16px',
    lg: '18px'
};
export var spinnerHeightOption = {
    sm: '10px',
    md: '14px',
    lg: '20px'
};
export var backgroundColorOption = {
    solid: {
        primary: {
            "default": 'buttonSolidDefaultBackgroundColor',
            hover: 'buttonSolidHoverBackgroundColor',
            pressed: 'buttonSolidActiveBackgroundColor',
            focussed: 'buttonSolidFocusBackgroundColors'
        },
        secondary: {
            "default": 'secondary500',
            hover: 'secondary600',
            pressed: 'secondary700',
            focussed: 'secondary500'
        },
        tertiary: {
            "default": 'tertiary500',
            hover: 'tertiary600',
            pressed: 'tertiary700',
            focussed: 'tertiary500'
        },
        error: {
            "default": 'error500',
            hover: 'error600',
            pressed: 'error700',
            focussed: 'error500'
        },
        warning: {
            "default": 'warning500',
            hover: 'warning600',
            pressed: 'warning700',
            focussed: 'warning500'
        },
        success: {
            "default": 'success500',
            hover: 'success600',
            pressed: 'success700',
            focussed: 'success500'
        },
        information: {
            "default": 'information500',
            hover: 'information600',
            pressed: 'information700',
            focussed: 'information500'
        }
    },
    soft: {
        primary: {
            "default": 'buttonSoftDefaultBackgroundColor',
            hover: 'buttonSoftHoverBackgroundColor',
            pressed: 'buttonSoftActiveBackgroundColor',
            focussed: 'buttonSoftFocusBackgroundColor'
        },
        secondary: {
            "default": 'secondary50',
            hover: 'secondary200',
            pressed: 'secondary300',
            focussed: 'secondary50'
        },
        tertiary: {
            "default": 'tertiary50',
            hover: 'tertiary200',
            pressed: 'tertiary300',
            focussed: 'tertiary50'
        },
        error: {
            "default": 'error50',
            hover: 'error200',
            pressed: 'error300',
            focussed: 'error50'
        },
        warning: {
            "default": 'warning50',
            hover: 'warning200',
            pressed: 'warning300',
            focussed: 'warning50'
        },
        success: {
            "default": 'success50',
            hover: 'success200',
            pressed: 'success300',
            focussed: 'success50'
        },
        information: {
            "default": 'information50',
            hover: 'information200',
            pressed: 'information300',
            focussed: 'information50'
        }
    },
    outline: {
        primary: {
            "default": 'primary50',
            hover: 'primary100',
            pressed: 'primary200',
            focussed: 'primary100'
        },
        secondary: {
            "default": 'secondary50',
            hover: 'secondary100',
            pressed: 'secondary200',
            focussed: 'secondary100'
        },
        tertiary: {
            "default": 'tertiary50',
            hover: 'tertiary100',
            pressed: 'tertiary200',
            focussed: 'tertiary100'
        },
        error: {
            "default": 'error50',
            hover: 'error100',
            pressed: 'error200',
            focussed: 'error100'
        },
        warning: {
            "default": 'warning50',
            hover: 'warning100',
            pressed: 'warning200',
            focussed: 'warning100'
        },
        success: {
            "default": 'success50',
            hover: 'success100',
            pressed: 'success200',
            focussed: 'success100'
        },
        information: {
            "default": 'information50',
            hover: 'information100',
            pressed: 'information200',
            focussed: 'information100'
        }
    },
    transparent: {
        primary: {
            "default": 'transparent',
            hover: 'primary100',
            pressed: 'primary100',
            focussed: 'primary25'
        },
        secondary: {
            "default": 'transparent',
            hover: 'secondary100',
            pressed: 'secondary100',
            focussed: 'secondary25'
        },
        tertiary: {
            "default": 'transparent',
            hover: 'tertiary100',
            pressed: 'tertiary100',
            focussed: 'tertiary25'
        },
        error: {
            "default": 'transparent',
            hover: 'error100',
            pressed: 'error100',
            focussed: 'error25'
        },
        warning: {
            "default": 'transparent',
            hover: 'warning100',
            pressed: 'warning100',
            focussed: 'warning25'
        },
        success: {
            "default": 'transparent',
            hover: 'success100',
            pressed: 'success100',
            focussed: 'success25'
        },
        information: {
            "default": 'transparent',
            hover: 'information100',
            pressed: 'information100',
            focussed: 'information25'
        }
    }
};
export var backgroundColorDisabledOption = {
    solid: 'buttonSolidDisabledBackgroundColor',
    outline: 'tertiary200',
    soft: 'buttonSoftDisabledBackgroundColor',
    transparent: 'transparent'
};
export var borderColorDisabledOption = {
    solid: 'tertiary300',
    soft: 'tertiary200',
    outline: 'tertiary200',
    transparent: 'transparent'
};
export var colorDisabledOption = {
    solid: 'buttonSolidDisabledColor',
    outline: 'tertiary500',
    soft: 'buttonSoftDisabledColor',
    transparent: 'tertiary400'
};
